import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InitialLoadingSpinnerService {
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  /**
   * Upon initial load, the app-shell displays a transparent image with loading state that registers
   * as the LCP for client side rendered pages. This is to removed once the app is loaded.
   */
  removeLoadingSpinner(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.document.getElementById('__pwa_loader_overlay__')?.remove();
  }
}
